import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { postJSON, getCSRFHeaders } from '@folklore/fetch';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useState, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useModalsComponentsManager } from '@panneau/core/contexts';
import { useActionProps } from '@panneau/core/hooks';
import Button from '@panneau/element-button';

var styles = {};

var _excluded = ["id", "title", "description", "endpoint", "action", "label", "icon", "value", "theme", "disabled", "onConfirmed", "valueLabelPath", "modalComponent", "withConfirmation", "className"];
var propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.node,
  description: PropTypes.node,
  endpoint: PropTypes.string,
  action: PropTypes.func,
  // Promise
  label: PropTypes.string,
  value: PropTypes.bool,
  icon: PropTypes.string,
  theme: PropTypes.string,
  disabled: PropTypes.bool,
  onConfirmed: PropTypes.func,
  valueLabelPath: PropTypes.string,
  modalComponent: PropTypes.string,
  withConfirmation: PropTypes.bool,
  className: PropTypes.string
};
var defaultProps = {
  title: null,
  description: null,
  endpoint: '/restore',
  action: null,
  label: null,
  icon: 'box-arrow-left',
  value: null,
  theme: 'warning',
  disabled: false,
  onConfirmed: null,
  valueLabelPath: null,
  modalComponent: 'confirm',
  withConfirmation: false,
  className: null
};
var RestoreAction = function RestoreAction(_ref) {
  var id = _ref.id,
    title = _ref.title,
    description = _ref.description,
    endpoint = _ref.endpoint,
    action = _ref.action,
    label = _ref.label,
    icon = _ref.icon,
    value = _ref.value,
    theme = _ref.theme,
    disabled = _ref.disabled,
    onConfirmed = _ref.onConfirmed,
    valueLabelPath = _ref.valueLabelPath,
    modalComponent = _ref.modalComponent,
    withConfirmation = _ref.withConfirmation,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var ModalComponents = useModalsComponentsManager();
  var ModalComponent = ModalComponents.getComponent(modalComponent);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    modalOpen = _useState2[0],
    setModalOpen = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var _useActionProps = useActionProps(id, value, valueLabelPath),
    ids = _useActionProps.ids,
    idLabels = _useActionProps.idLabels,
    modalKey = _useActionProps.modalKey;
  var onOpen = useCallback(function () {
    setModalOpen(true);
  }, [setModalOpen]);
  var onClose = useCallback(function () {
    setModalOpen(false);
  }, [setModalOpen]);
  var onConfirm = useCallback(function () {
    return (action !== null ? action(ids) : postJSON(endpoint, {
      ids: ids
    }, {
      credentials: 'include',
      headers: getCSRFHeaders(),
      _method: 'DELETE'
    })).then(function (response) {
      if (onConfirmed !== null) {
        onConfirmed(response);
      }
      if (withConfirmation) {
        onClose();
      }
    })["catch"](function (err) {
      setError(err);
    });
  }, [ids, endpoint, onClose, setError, withConfirmation]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, Object.assign({
    className: classNames([styles.container, _defineProperty({}, className, className !== null)]),
    label: label,
    icon: icon,
    onClick: withConfirmation ? onOpen : onConfirm,
    disabled: disabled,
    theme: disabled ? 'secondary' : theme
  }, props)), modalOpen ? /*#__PURE__*/React.createElement(ModalComponent, {
    id: modalKey,
    title: title || /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "c6nfry",
      defaultMessage: [{
        "type": 0,
        "value": "Restore"
      }]
    }),
    onConfirm: onConfirm,
    onClose: onClose,
    confirmButton: {
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "UaVu03",
        defaultMessage: [{
          "type": 0,
          "value": "Confirm"
        }]
      }),
      theme: 'danger'
    },
    cancelButton: {
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "PyxZY2",
        defaultMessage: [{
          "type": 0,
          "value": "Cancel"
        }]
      })
    }
  }, description !== null ? description : /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "M49yWb",
    defaultMessage: [{
      "type": 0,
      "value": "The following items will be restored: "
    }, {
      "type": 1,
      "value": "ids"
    }, {
      "type": 0,
      "value": ". Are you sure you want to continue?"
    }],
    values: {
      ids: idLabels
    }
  })), error !== null ? /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "cutyQH",
    defaultMessage: [{
      "type": 0,
      "value": "An error has occured."
    }]
  }) : null) : null);
};
RestoreAction.propTypes = propTypes;
RestoreAction.defaultProps = defaultProps;

export { RestoreAction as default };
